import React from "react";
import { Backdrop } from "@mui/material";
import LoaderAnimationComponent from "../assets/lottie/LoaderAnimation/LoaderAnimationComponent";
import { absoluteUrl } from "../_helper";

const Loader = () => {
  return (
    <Backdrop
      className="!tw-bg-[#f5f6f7]"
      style={{ zIndex: 9999 }}
      open={true}
      onClick={(e) => e.preventDefault()}
    >
      <div className="fs-16 tw-flex tw-items-center tw-flex-col">
        <img
          src={absoluteUrl("imgs/logoForLoader.png")}
          className="header-logo !tw-w-20"
          alt="UNITERS ACADEMY"
        />
        <LoaderAnimationComponent />
      </div>
    </Backdrop>
  );
};

export default Loader;
